import React from 'react';

const Footer: React.FC = () => {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <footer className="bg-gray-900 text-white py-12 px-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-8">
          {/* Company Info */}
          <div>
            <h3 className="text-soez-orange text-xl font-bold mb-4">SoEz</h3>
            <p className="text-gray-400 mb-3">
              Enterprise communication platform built for security-conscious organizations.
            </p>
            <p className="text-gray-400 font-semibold">Secure. Smart. Simple.</p>
          </div>

          {/* Platform Links */}
          <div>
            <h3 className="text-soez-orange text-xl font-bold mb-4">Platform</h3>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => scrollToSection('features')}
                  className="text-gray-400 hover:text-soez-orange transition-colors"
                >
                  Features
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('why-choose')}
                  className="text-gray-400 hover:text-soez-orange transition-colors"
                >
                  Why SoEz
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('use-cases')}
                  className="text-gray-400 hover:text-soez-orange transition-colors"
                >
                  Use Cases
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-gray-400 hover:text-soez-orange transition-colors"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          {/* Industries */}
          <div>
            <h3 className="text-soez-orange text-xl font-bold mb-4">Industries</h3>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => scrollToSection('use-cases')}
                  className="text-gray-400 hover:text-soez-orange transition-colors"
                >
                  Corporate
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('use-cases')}
                  className="text-gray-400 hover:text-soez-orange transition-colors"
                >
                  Financial Services
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('use-cases')}
                  className="text-gray-400 hover:text-soez-orange transition-colors"
                >
                  Education
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('use-cases')}
                  className="text-gray-400 hover:text-soez-orange transition-colors"
                >
                  Healthcare
                </button>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-soez-orange text-xl font-bold mb-4">Contact</h3>
            <a
              href="mailto:sales@soez.co.za"
              className="text-gray-400 hover:text-soez-orange transition-colors block mb-3"
            >
              sales@soez.co.za
            </a>
            <p className="text-gray-400 text-sm">Available for enterprise inquiries and partnerships</p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 pt-8 text-center">
          <p className="text-gray-500 text-sm">
            &copy; 2025 SoEz. All rights reserved. | Built for enterprises that demand excellence.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
